export enum AnswerVariant {
  YesOrNo = 'YES_OR_NO',
  NewOfferCodeMobile = 'YES_OR_NO_MOBILE',
  TermsAndConditions = 'TERMS_AND_CONDITIONS',
  NotRecognizedAccount = 'NOT_RECOGNIZED_ACCOUNT',
  NotRecognizedAccountMobile = 'NOT_RECOGNIZED_ACCOUNT_MOBILE',
  NewOfferCode = 'NEW_OFFER_CODE',
}
